export default __webpack_public_path__ + "static/media/bernhard.5b23f5fc.png";